"use client"; 
import RegisterSection from "@/components/section/auth/register-section";
import { initAuthListener } from "@/store/useAuthStore";
import { useEffect, useState } from "react";

export default function Page() {
  useEffect(() => {
    initAuthListener();
  }, []);

  return (
    <div className="">
      <RegisterSection />
    </div>
  );
}
